import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  user-select: none;
`;

export const StyledTitle = styled.span`
  ${setFontVariant('listItem4', colorsPalettes.bluegrey[100])};
`;

export const StyledContent = styled.span`
  ${setFontVariant('body2', colorsPalettes.bluegrey[100])};
`;

export const StyledLink = styled.button`
  ${setFontVariant('body2', colorsPalettes.blue[300])};
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;

  &:hover {
    color: ${colorsPalettes.blue[300]};
  }
`;
